<template>
  <div class="GroupOverview">
    <navBar/>

    <banner2 :banner-h="h1" :banner-p="P1" :banner-img="Img1"/>
    <!-- 关于企业 -->
    <div class="about-bg">
      <div id="about" class="about">
        <div class="about-top">
          <div class="about-top-l">
            <span> 关于企业 </span>
            <dl v-html="companyInfo.content">
            </dl>
          </div>
          <div class="about-top-r">
            <div class="img-yinying"/>
            <img
                :src="companyInfo.image_input"
                alt=""
            />
          </div>
        </div>
        <stat/>
      </div>
    </div>
    <!-- 企业文化 -->
    <div id="CultureInfo" class="qywh">
      <h1>企业文化</h1>
      <div class="qywh-item">
        <div v-for="(item, index) in culture" :key="index" class="qywh-item1">
          <div class="qywh-thumb">
            <img :src="item.thumb" alt=""/>
            <p class="qywh-text">
              {{ item.title }}
            </p>
          </div>
          <div class="qywh-item2">
            <p class="qywh-text2 text2-2">
              {{ item.content }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <footer2/>
  </div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
import stat from "../components/stat.vue";

export default {
  name: "App",
  components: {
    footer2,
    banner2,
    stat,
  },
  data() {
    return {
      h1: "企业概况",
      P1: "欢迎加入我们",
      Img1: require("../assets/img/bannerjituan.png"),
      culture: [
        {
          id: 1,
          title: "企业定位",
          content: "现代化综合服务型第三方物流企业",
          thumb: require("../assets/img/编组5.png"),
        },
        {
          id: 2,
          title: "企业理念",
          content: "经济实惠，运输快捷",
          thumb: require("../assets/img/编组10.png"),
        },
        {
          id: 3,
          title: "企业使命",
          content: "基于供应链的全程物流服务，推进中国物流行业发展",
          thumb: require("../assets/img/编组14.png"),
        },
        {
          id: 4,
          title: "企业愿景",
          content: "安全、快捷、实惠",
          thumb: require("../assets/img/编组15.png"),
        },
      ],
      companyInfo: '',
      siteInfo:{}
    };
  },
  created() {
    let that = this
    this.siteInfo = this.commFunc.getSession('setSiteInfoByStore')
    this.culture.forEach(
        (item) => {
          if(item.id == 1){
            item.content = that.siteInfo.qydw
          }else if(item.id == 2){
            item.content = that.siteInfo.qyln
          }else if(item.id == 3){
            item.content = that.siteInfo.qysm
          }else if(item.id == 4){
            item.content = that.siteInfo.qyyj
          }
        }
    )
    this.aboutCompany()
  },
  mounted() {
  },
  methods: {
    aboutCompany() {
      this.reqApi.getCompanyDetail(null, (res) => {
        console.log('企业介绍', res);
        this.companyInfo = res
      }, (err) => {
        //业务错误返回
        console.log(err)
      })
    }
  },
};
</script>

<style scoped>
.GroupOverview {
  width: 100vw;
  margin: 0 auto;
}

.about {
  display: flex;
  padding: 100px 50px 20px 50px;
  flex-flow: column;
}

.about-bg {
  background-image: url("../assets/img/蒙版.png");
}

.about-top {
  /* position: relative;
  display: flex; */
  display: flex;
  justify-content: space-between;
}

.about-top-l {
  width: 70%;
  padding-right: 10px;
}

.about-top-l span {
  font-size: 32px;
}

.img-yinying {
  position: absolute;
  top: 58px;
  left: -17px;
  width: 17px;
  height: 408px;
  background: #f8f8f8;
}

.about-top-r img {
  width: 487px;
  height: 517px;
}

.qywh {
  width: 100%;
  height: 598px;
  background-color: rgba(248, 248, 248, 1);
}

.qywh h1 {
  color: rgba(68, 68, 68, 1);
  font-size: 32px;
  line-height: 134px;
  text-align: center;
}

.qywh-item {
  margin: 30px 200px;
  justify-content: space-between;
  display: flex;
}

.qywh-item1 {
  /* height: 348px; */
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin: 0px 20px 0px 0px;
  padding: 20px 15px 0 15px;
  display: flex;
  width: 25%;
  justify-content: center;
  align-items: center;
  flex-flow: column;
}

.qywh-item1 .qywh-thumb {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}

.qywh-item1 .qywh-thumb > img {
  border-radius: 100%;
  width: 90px;
  height: 90px;
}

.qywh-item1 .qywh-item2 {
  display: flex;
  flex-flow: column;
  flex-grow: 1; /* 占据剩余空间 */
}

.qywh-text {
  color: rgba(68, 68, 68, 1);
  font-size: 24px;
}

.qywh-text2 {
  text-align: center;
  color: rgba(68, 68, 68, 1);
  font-size: 18px;
  line-height: 28px;
}

/* 发展历程 */
.DevelopmentHistory {
  width: 1920;
  height: 527px;
  background-image: url("../assets/img/fazhan_bg.png");
}

.DevelopmentHistory_cont {
  width: 1200px;
  margin: 0 auto;
}

.DevelopmentHistory_cont_img img {
  margin-top: 61px;
  width: 32px;
  height: 32px;
}

.DevelopmentHistory_cont_img1 {
  float: left;
}

.DevelopmentHistory_cont_img2 {
  float: right;
}

.DevelopmentHistory_cont > h1 {
  text-align: center;
  margin-top: 64px;

  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #444444;
  line-height: 45px;
}

.DevelopmentHistory_cont_ul {
  display: flex;
  margin-top: 12px;
  margin-left: 59px;
  justify-content: space-around;
}

.DevelopmentHistory_cont_ul ul p {
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #23337f;
  line-height: 33px;
}

.DevelopmentHistory_cont_ul li {
  margin-top: 8px;
  list-style-type: none;

  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  line-height: 24px;
}
</style>
